export default class InputDevice{

    id?: string = '';

    serial_number: string = '';

    adc_customer_id: string = '';

    imei: string = '';

    hub_type: string = '';

    builder_id: number = 0;

    property_id: number = 0;

    hub_account_id: string = '';

    description?: string = '';

    comments?: string = '';

    mac?: string = '';

    logs?: Array<DeviceActivationLog>;

    adc_device_id?: number;

    delay_animation?: boolean;
}

export interface DeviceActivationLog {
  id: number;
  serial_number: string;
  action: string;
  created_by: string;
  hub_type: string;
  lock_type: string;
  created_by_email: string;
  created_on: Date | null;
  property_id: number;
};
